module.exports = __webpack_public_path__ + "static/media/sr_process.ff07882b.jpg";